import { format } from 'date-fns';
import { UserProfession } from '~/enums/UserProfession';
import { convertTimeToMinutes } from '~/components/Request/multiday/utils';
import { type IShiftDetailsFormValues } from '~/components/ShiftRequestRedesign/ShiftDetails/ShiftDetailsForm/useShiftDetailsForm';
import { type IMultiDayJobPayload } from '../types';

interface IBuildJobPayloadsOptions {
  duplicate?: boolean;
}

export const buildJobPayloads = (
  formValues: IShiftDetailsFormValues,
  options?: IBuildJobPayloadsOptions,
): IMultiDayJobPayload[] => {
  const professionCode = UserProfession.getCode(formValues.professionType) as string;
  const normalizedCode = UserProfession.getNormalizedCode(professionCode) as string;

  return formValues.dates.map((date) => {
    const dateKey = date.toISOString();
    const override = formValues.shiftOverrides?.[dateKey];

    const arrivalTime = override?.arrivalTime ?? formValues.arrivalTime;
    const departureTime = override?.departureTime ?? formValues.departureTime;
    const mealBreakDuration = override?.mealBreakDuration ?? formValues.mealBreakDuration;
    const isMealBreakPaid = override?.isMealBreakPaid ?? formValues.isMealBreakPaid;
    const rate = override?.rate ?? formValues.rate;
    const specialty = override?.preferredSpecialty ?? formValues.preferredSpecialty;
    const isAssistedHygiene = override?.isAssistedHygiene ?? formValues.isAssistedHygiene;
    const procedures = override?.procedures ?? formValues.procedures;
    const autoConfirm = override?.autoConfirm ?? formValues.autoConfirm;

    return {
      profession: normalizedCode,
      localDate: format(date, 'yyyy-MM-dd'),
      localStart: arrivalTime,
      localEnd: departureTime,
      break_time: convertTimeToMinutes(mealBreakDuration),
      is_break_paid: isMealBreakPaid,
      rate: rate ?? 0,
      specialty,
      isAssistedHygiene: isAssistedHygiene ?? false,
      procedures,
      autoFill: autoConfirm.eligibleProfessionals,
      autofillOptions: {
        favorite: autoConfirm.favorites,
      },
      ...(options?.duplicate ? { duplicate: true } : {}),
    };
  });
};
